import {
  createSlice,
  type PayloadAction,
} from '@reduxjs/toolkit';
import {
  type GameWinner,
  type GameWinnersState
} from './types';
import {
  WINNERS_ITEMS_LIMIT
} from '../config';

export const initialState: GameWinnersState = {
  winners: [],
};

export const gameWinnersSlice = createSlice({
  name: 'game-winners',
  initialState,
  reducers: {
    setGameWinners: (state, action: PayloadAction<GameWinner[]>) => {
      state.winners = action.payload;
    },
    addGameWinner: (state, action: PayloadAction<GameWinner>) => {
      state.winners.unshift(action.payload);
      if (state.winners.length > WINNERS_ITEMS_LIMIT) {
        state.winners = state.winners.slice(0, WINNERS_ITEMS_LIMIT);
      };
    }
  },
});

export const { setGameWinners, addGameWinner } = gameWinnersSlice.actions;
export const gameWinnersReducer = gameWinnersSlice.reducer;
